import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Mics';

const MicsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default MicsPage;
